module.exports = __webpack_public_path__ + "fonts/OpenSans400italic.2cb96492.woff";